module.exports = __webpack_public_path__ + "img/trash.bc2f7bfa.svg";